import { render, staticRenderFns } from "./ViewPdfButton.vue?vue&type=template&id=1a987505&"
import script from "./ViewPdfButton.vue?vue&type=script&lang=js&"
export * from "./ViewPdfButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewPdfButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports